<div class="container-fluid special-content">
  <div class="container section-wrapper">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 mb-4 mb-lg-0">
        <h2 class="section-title">{{ 'Where To Stay' | translate }}</h2>
        <h5 class="section-subtitle" role="heading" aria-level="2">{{ 'Graded & Sustainable' | translate }}</h5>
        <p class="section-text">
          {{ 'Where To Stay Description' | translate }}
        </p>
        <button class="btn btn-custom" (click)="btnClick()">{{ 'See more Accommodations' | translate }}</button>
      </div>

      <div class="col-lg-6 col-md-12">
        <!-- min-height on .image-stack (see scss) reserves the space up front,
             so this section doesn't jump once the API response arrives -->
        <div class="image-stack">
          <img
            *ngFor="let img of accommodations; let i = index; trackBy: trackByImage"
            [src]="img"
            [alt]="'Accommodation ' + (i + 1)"
            class="img-fluid"
            width="220"
            height="320"
            decoding="async"
            (error)="onImageError($event)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
